import { css } from 'styled-components'
import { BREAKPOINTS } from '../GlobalTheme'

/**
 * Legacy layout hack used across the app: `line-height: 0` makes a single-line <p>
 * contribute no vertical space, with position coming from explicit margins instead.
 *
 * It breaks as soon as the text WRAPS - every line box is 0 tall, so line 2 paints on
 * top of line 1. That never happens at desktop column widths but is guaranteed on a
 * phone, so below the shell breakpoint we restore a real line-height.
 *
 * Desktop rendering is unchanged; only narrow viewports differ.
 */
export const zeroLineHeight = css`
  line-height: 0px;
  /* The premise above - that these never wrap at desktop column widths - is false: the APP Version
     tiles, the Charges energy column, the Chargers local-name cell and the charger-group version
     strings all wrap at 1280 and print line two directly on line one. Keeping them to a single line
     is what makes a zero line box safe; callers with a definite width truncate on top of this. */
  white-space: nowrap;

  @media (max-width: ${BREAKPOINTS.shell}px) {
    line-height: normal;
    white-space: normal;
  }
`

/**
 * Pairs with `zeroLineHeight`: text may only wrap where the line-height is real.
 *
 * Above the breakpoint these elements keep `line-height: 0`, so a second line would paint directly
 * on top of the first - which is exactly what happened to the version strings in the charger-group
 * cards at 1280px. There, long values clip at the cell edge instead, which is what they always did.
 */
export const wrapWhenNarrow = css`
  @media (max-width: ${BREAKPOINTS.shell}px) {
    overflow-wrap: anywhere;
  }
`
